const TRACKING_PATH = '/tracking';
const CLAIM_ID_PARAM = 'claimid';
const RETURN_URL_PARAM = 'returnUrl';

const isTrackingPageUrl = (url) => {
    return url.pathname === TRACKING_PATH && url.searchParams.has(CLAIM_ID_PARAM);
};

const getCurrentPageUrl = () => {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};

export const buildParcelExternalTrackingUrl = (parcelUrl, externalNumber) => {
    if (!parcelUrl) {
        return parcelUrl;
    }

    const resolvedUrl = parcelUrl.replace('XXXX', externalNumber);

    try {
        const url = new URL(resolvedUrl, window.location.origin);
        if (!isTrackingPageUrl(url)) {
            return resolvedUrl;
        }

        url.searchParams.set(RETURN_URL_PARAM, getCurrentPageUrl());
        return url.toString();
    } catch (e) {
        return resolvedUrl;
    }
};

export const isSafeReturnUrl = (value) => {
    if (!value || typeof value !== 'string') {
        return false;
    }

    return value.startsWith('/') && !value.startsWith('//');
};



// WEBPACK FOOTER //
// ./App/services/trackingLink.js